import React from 'preact/compat';
import { JSX } from 'preact';

export default function CloseIcon(props: Omit<JSX.SVGAttributes<SVGSVGElement>, 'viewBox'>) {
    return (
        <svg viewBox='0 0 32 32' {...props}>
            <path d='M32 3.222l-3.222-3.222-12.778 12.778-12.778-12.778-3.222 3.222 12.778 12.778-12.778 12.778 3.222 3.222 12.778-12.778 12.778 12.778 3.222-3.222-12.778-12.778z' />
        </svg>
    );
}
